import { combineReducers } from "@reduxjs/toolkit";

import userReducer from "@store/slices/user";
import statsReducer from "@store/slices/stats";

export default combineReducers({
  user: userReducer,
  stats: statsReducer,
});
